import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-monitor-jst',
  templateUrl: './monitor-jst.component.html'
})
export class MonitorJstComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
